const numberToWords = {
  1: 'first',
  2: 'second',
  3: 'third',
  4: 'fourth',
}

const titleParser = {
  'Legal': 'LEGAL_ADDRESS',
  'Headquarters': 'HEADQUARTERS_ADDRESS',
  'Other Addresses': 'ADDRESSES',
}

const createAddress = (title, rootPath) => {
  const makePath = (path) => `$.${rootPath}.${path}`
  const prefix = titleParser[title]
  const gatTextForLine = (index) => {
    const name = title.toLowerCase() + ' address'
    return index === 0
      ? `The mandatory first ${name} element.`
      : `An optional additional ${numberToWords[index + 1]}  ${name}  element.`
  }
  const gatLabelForLine = (index) => {
    return index === 0 ? `First ${title} Address Line` : `Additional ${title} Address Line`
  }

  const createLine = (index) => ({
    jsonPath: makePath(`addressLines[${index}]`),
    label: gatLabelForLine(index),
    type: 'STRING',
    fieldId: `LEIREC_${prefix}_LINE_${index + 1}`,
    text: gatTextForLine(index),
  })

  return [
    {
      jsonPath: makePath('country'),
      label: 'Country',
      getValue: ({ code, name, }) => `${code} | ${name}`,
      type: 'RESOURCE',
      fieldId: `LEIREC_${prefix}_COUNTRY`,
      text: 'The mandatory country code of the legal entity\'s address.',
    },
    {
      fieldId: `LEIREC_${prefix}_LINE_1`,
      jsonPath: makePath('FirstAddressLine'),
      label: 'First Legal Address Line',
      text: 'The mandatory first legal address element.',
      type: 'STRING',
    },
    {
      jsonPath: makePath('city'),
      label: 'City',
      type: 'STRING',
      fieldId: `LEIREC_${prefix}_CITY`,
      text: 'The mandatory city line of the address.',
    },
    {
      jsonPath: makePath('region'),
      label: 'Region',
      getValue: ({ code, }) => code,
      type: 'RESOURCE',
      fieldId: `LEIREC_${prefix}_REGION`,
      text: 'The code for a region (state, province, county, canton, etc) as used in postal addresses for the country of this address.',
    },
    {
      jsonPath: makePath('postalCode'),
      label: 'Postal Code',
      type: 'STRING',
      fieldId: `LEIREC_${prefix}_POSTAL_CODE`,
      text: 'The postal code of this address as specified by the local postal service.',
    },
    {
      jsonPath: makePath('addressNumber'),
      label: 'Address Number',
      type: 'STRING',
      fieldId: `LEIREC_${prefix}_NUMBER`,
      text: '',
    },
    {
      jsonPath: makePath('addressNumberWithinBuilding'),
      label: 'Address Number within Building',
      type: 'STRING',
      fieldId: `LEIREC_${prefix}_NUMBER_WITHIN_BUILDING`,
      text: '',
    },
    {
      jsonPath: makePath('mailRouting'),
      label: 'Address Mail Routing',
      type: 'STRING',
      fieldId: `LEIREC_${prefix}_MAIL_ROUTING`,
      text: '',
    },
    createLine(0),
    createLine(1),
    createLine(2),
    createLine(3),
  ]
}

export default [
  ...createAddress('Legal', 'legalAddress'),
  ...createAddress('Headquarters', 'headquartersAddress'),
  ...createAddress('Other Addresses', 'addresses[0]'),
  ...createAddress('Other Addresses', 'addresses[1]'),
  ...createAddress('Other Addresses', 'addresses[2]'),
  ...createAddress('Other Addresses', 'addresses[3]'),
]



// WEBPACK FOOTER //
// ./src/utils/challenge/addresses.js